import { useRouter } from '@tanstack/router'
import { useEffect } from 'react'

import { useBoundStore } from '../store/store'

const useTheme = () => {
  const theme = useBoundStore(state => state.common.theme)
  const casinoTheme = useBoundStore(state => state.common.casinoTheme)
  const sportsTheme = useBoundStore(state => state.common.sportsTheme)
  const themeSponsors = useBoundStore(state => state.common.themeSponsors)
  const setCasinoTheme = useBoundStore(state => state.common.setCasinoTheme)
  const setSportsTheme = useBoundStore(state => state.common.setSportsTheme)
  const setThemeSponsors = useBoundStore(
    state => state.common.setThemeSponsors,
  )
  const router = useRouter()
  const pathname = router.state.latestLocation.pathname

  useEffect(() => {
    const isSports = pathname.startsWith('/sports')
    const isSponsors = pathname.startsWith('/sponsors')
    if (isSports) {
      setSportsTheme(sportsTheme)
    } else if (isSponsors) {
      setThemeSponsors(themeSponsors)
    } else {
      setCasinoTheme(casinoTheme)
    }
  }, [pathname])

  useEffect(() => {
    if (theme === 'light' && !document.body.classList.contains('theme-light')) {
      document.body.classList.remove('theme-dark')
      document.body.classList.add('theme-light')
    } else if (
      theme === 'dark' &&
      !document.body.classList.contains('theme-dark')
    ) {
      document.body.classList.remove('theme-light')
      document.body.classList.add('theme-dark')
    }
  }, [theme])
}

export default useTheme
